export default __webpack_public_path__ + "static/bell-c42b52425449cd6eac066947266b7d77.png";